import {
  yesNoUI,
  titleUI,
  descriptionUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-V2-schema.json';
import {
  directDepositTitle,
  DirectDepositDescription,
} from '../../components/additionalInformation/DirectDeposit';
import ConfirmationDirectDeposit from '../../components/confirmationFields/ConfirmationDirectDeposit';

// A veteran without a bank account must not submit stale entered account data,
// so everything under `directDeposit` except the `hasNoAccount` answer is cleared.
// `view:prefilledBankAccount` is the prefill source and is intentionally kept.
export const updateFormData = (_oldData, newData) =>
  newData?.directDeposit?.hasNoAccount === true
    ? { ...newData, directDeposit: { hasNoAccount: true } }
    : newData;

export default {
  uiSchema: {
    'ui:confirmationField': ConfirmationDirectDeposit,
    ...titleUI(directDepositTitle),
    ...descriptionUI(DirectDepositDescription),
    directDeposit: {
      hasNoAccount: yesNoUI({
        title: 'Do you have a bank account for direct deposit?',
        yesNoReverse: true,
        errorMessages: {
          required: 'Select a response',
        },
      }),
    },
  },
  schema: {
    type: 'object',
    required: ['directDeposit'],
    properties: {
      directDeposit: {
        type: 'object',
        required: ['hasNoAccount'],
        properties: {
          hasNoAccount:
            fullSchema.properties.directDeposit.properties.hasNoAccount,
        },
      },
    },
  },
};
